import { render, staticRenderFns } from "./BackofficeSuprimentosAgrupados.vue?vue&type=template&id=7080cdf8&scoped=true"
import script from "./BackofficeSuprimentosAgrupados.vue?vue&type=script&lang=ts"
export * from "./BackofficeSuprimentosAgrupados.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeSuprimentosAgrupados.vue?vue&type=style&index=0&id=7080cdf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7080cdf8",
  null
  
)

export default component.exports